<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12">
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-text id="nameInput">Nome *</b-form-text>
            <b-form-input
              v-model="form.NAME"
              placeholder="Nome *"
              :formatter="notEmpty"
              maxlength="24"
              size="sm"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
              id="nameInput"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>
            <b-form-text id="input-model">Modelo *</b-form-text>
            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <searchable-select
              v-model="form.FK_MODEL"
              :options="actuatorsModels"
              text-field="NAME"
              value-field="ID"
              :state="modelState"
              :clearable="false"
              placeholder="Selecione o modelo *"
            />
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>

          <div class="col-xs-12">
            <div class="group-inputs-title">Localização</div>
            <b-form-text id="input-latitude">Latitude</b-form-text>
            <!-- <b-form-text v-show="form.LATITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="Latitude"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
              id="input-latitude"
            />
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text id="input-latitude">Longitude</b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="Longitude"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
              id="input-latitude"
            />
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>
          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">Parâmetros</div>
            <b-form-text id="closureTimeInputLiveHelp">
              Tempo de fechamento (s)
            </b-form-text>
            <b-form-input
              v-model="form.CLOSURE_TIME"
              type="number"
              min="1"
              size="sm"
              aria-describedby="closureTimeInputLiveHelp"
              state="valid"
            />
            <b-form-text id="closureTimeInputLiveHelp">
              Tempo de descanso (min)
            </b-form-text>
            <b-form-input
              v-model="form.REST_TIME"
              type="number"
              min="0"
              size="sm"
              aria-describedby="closureTimeInputLiveHelp"
              state="valid"
            />
            <b-form-text id="input-pres">
              Pressão requerida (bar)
            </b-form-text>
            <!-- <b-form-text v-show="form.REQ_PRES">
              Pressão requerida (bar)
            </b-form-text> -->

            <b-form-input
              v-model="form.REQ_PRES"
              placeholder="Informe a pressão"
              :formatter="notEmpty"
              :state="reqPresState"
              id="input-pres"
              size="sm"
            />
          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">Sensor de feedback</div>
            <searchable-select
              v-model="form.FK_SENSOR"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <b-form-text v-show="form.FK_SENSOR && form.POS_SENSOR">Medição do Sensor</b-form-text>
            <b-form-select
              v-if="form.FK_SENSOR"
              v-model="form.POS_SENSOR"
              :state="sensorMeasureState"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <template v-if="form.FK_SENSOR && form.POS_SENSOR !== null">
              <b-form-text>Condição de ativação</b-form-text>
              <b-input-group size="sm">
                <b-form-select
                  v-model="form.ACTION_SENSOR"
                  :state="actionSensorState"
                  style="max-width: 140px"
                >
                  <template slot="first">
                    <option :value="null">Condição</option>
                  </template>
                  <option :value="0">Maior que</option>
                  <option :value="1">Menor que</option>
                </b-form-select>
                <b-form-input
                  v-model="form.VALUE_SENSOR"
                  placeholder="Valor"
                  type="number"
                  :state="valueSensorState"
                />
              </b-input-group>
            </template>
            <template v-if="form.FK_SENSOR">
              <b-form-checkbox
                v-model="form.FEEDBACK_ERR_ENABLED"
                :value="1"
                :unchecked-value="0"
                size="sm"
                class="mt-2"
                switch
              >
                Habilitar intertravamento
              </b-form-checkbox>
              <b-form-text>Tempo máximo de confirmação (s)</b-form-text>
              <b-form-input
                v-model.number="form.FEEDBACK_ERR_TIME"
                type="number"
                min="1"
                size="sm"
                :state="feedbackErrTimeState"
              />
            </template>
            <div class="group-inputs-title">Sensor de bloqueio de segurança</div>
            <searchable-select
              v-model="form.FK_SENSOR_LOCK"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <b-form-text v-show="form.FK_SENSOR_LOCK && form.POS_SENSOR_LOCK">Medição do Sensor</b-form-text>
            <b-form-select
              v-if="form.FK_SENSOR_LOCK"
              v-model="form.POS_SENSOR_LOCK"
              :state="sensorMeasureLockState"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR_LOCK
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <template v-if="form.FK_SENSOR_LOCK && form.POS_SENSOR_LOCK !== null">
              <b-form-text>Faixa permitida para partida e operação</b-form-text>
              <b-input-group size="sm">
                <b-form-input
                  v-model="form.MIN_VALUE_SENSOR_LOCK"
                  placeholder="Mínimo"
                  type="number"
                  :state="lockRangeState"
                />
                <b-form-input
                  v-model="form.MAX_VALUE_SENSOR_LOCK"
                  placeholder="Máximo"
                  type="number"
                  :state="lockRangeState"
                />
              </b-input-group>
            </template>
            <div class="group-inputs-title">Sensor de posição</div>
            <searchable-select
              v-model="form.FK_SENSOR_POS"
              :options="positionSensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <div class="group-inputs-title" id="input-hydro">Hidrômetro</div>
            <!-- <b-form-text v-show="form.FK_HYDRO">Hidrômetro</b-form-text> -->
            <searchable-select
              v-model="form.FK_HYDRO"
              :options="hydros"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Selecione o hidrômetro"
            />
            <div class="group-inputs-title">Sensor de pressão</div>
            <searchable-select
              v-model="form.FK_SENSOR_PRESSURE"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />

            <b-form-text id="input-obs">Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              size="sm"
              id="input-obs"
            />
          </div>
        </b-form>
      </div>
      <b-modal
       ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >

        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>

          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" block @click="$emit('close-form')"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "pump-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    actuatorsModels: Array,
    hydros: Array,
    sensors: {
      type: Array,
      default() { return []; }
    },
    auxSensors: {
      type: Array,
      default() { return []; }
    },
    itemToEdit: [Number, Object]
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        FK_MODEL: null,
        CLOSURE_TIME: null,
        REST_TIME: null,
        LATITUDE: null,
        LONGITUDE: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        VALUE_SENSOR: null,
        FEEDBACK_ERR_ENABLED: 0,
        FEEDBACK_ERR_TIME: 300,
        FK_SENSOR_LOCK: null,
        POS_SENSOR_LOCK: null,
        MIN_VALUE_SENSOR_LOCK: null,
        MAX_VALUE_SENSOR_LOCK: null,
        FK_SENSOR_POS: null,
        FK_SENSOR_PRESSURE: null,
        REQ_PRES: null,
        NOTE: null
      }
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.NAME = this.itemToEdit.NAME;
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.CLOSURE_TIME = this.itemToEdit.CLOSURE_TIME;
          this.form.REST_TIME = this.itemToEdit.REST_TIME;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.REQ_PRES = this.itemToEdit.REQ_PRES;
          this.form.FK_HYDRO = this.itemToEdit.FK_HYDRO;
          this.form.FK_SENSOR = this.itemToEdit.FK_SENSOR;
          this.form.POS_SENSOR = this.itemToEdit.POS_SENSOR;
          this.form.ACTION_SENSOR = this.itemToEdit.ACTION_SENSOR;
          this.form.VALUE_SENSOR = this.itemToEdit.VALUE_SENSOR;
          this.form.FEEDBACK_ERR_ENABLED = this.itemToEdit.FEEDBACK_ERR_ENABLED || 0;
          this.form.FEEDBACK_ERR_TIME = this.itemToEdit.FEEDBACK_ERR_TIME || 300;
          this.form.FK_SENSOR_LOCK = this.itemToEdit.FK_SENSOR_LOCK;
          this.form.POS_SENSOR_LOCK = this.itemToEdit.POS_SENSOR_LOCK;
          this.form.MIN_VALUE_SENSOR_LOCK = this.itemToEdit.MIN_VALUE_SENSOR_LOCK;
          this.form.MAX_VALUE_SENSOR_LOCK = this.itemToEdit.MAX_VALUE_SENSOR_LOCK;
          this.form.FK_SENSOR_POS = this.itemToEdit.FK_SENSOR_POS;
          this.form.FK_SENSOR_PRESSURE = this.itemToEdit.FK_SENSOR_PRESSURE;
          this.form.NOTE = this.itemToEdit.NOTE;
        }
      }
    }
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    reqPresState() {
      let reqPres = String(Number(this.form.REQ_PRES));
      if (reqPres == "NaN" || reqPres < 0) return false;
      return true;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    sensorMeasureState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR === null) return false;
      return true;
    },
    actionSensorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR !== null && this.form.ACTION_SENSOR === null) return false;
      return true;
    },
    valueSensorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR !== null && (this.form.VALUE_SENSOR === null || this.form.VALUE_SENSOR === "")) return false;
      return true;
    },
    feedbackErrTimeState() {
      if (this.form.FEEDBACK_ERR_ENABLED && (!this.form.FEEDBACK_ERR_TIME || this.form.FEEDBACK_ERR_TIME < 1)) return false;
      return true;
    },
    sensorMeasureLockState() {
      if (this.form.FK_SENSOR_LOCK && this.form.POS_SENSOR_LOCK === null) return false;
      return true;
    },
    lockRangeState() {
      if (this.form.FK_SENSOR_LOCK && this.form.POS_SENSOR_LOCK !== null) {
        if (this.form.MIN_VALUE_SENSOR_LOCK === null || this.form.MIN_VALUE_SENSOR_LOCK === "") return false;
        if (this.form.MAX_VALUE_SENSOR_LOCK === null || this.form.MAX_VALUE_SENSOR_LOCK === "") return false;
        if (Number(this.form.MIN_VALUE_SENSOR_LOCK) >= Number(this.form.MAX_VALUE_SENSOR_LOCK)) return false;
      }
      return true;
    },
    positionSensors() {
      return this.sensors.filter((s) => s.NAME_MODEL === "SPG");
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME: "",
        FK_MODEL: null,
        CLOSURE_TIME: null,
        REST_TIME: null,
        LATITUDE: null,
        LONGITUDE: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        VALUE_SENSOR: null,
        FEEDBACK_ERR_ENABLED: 0,
        FEEDBACK_ERR_TIME: 300,
        FK_SENSOR_LOCK: null,
        POS_SENSOR_LOCK: null,
        MIN_VALUE_SENSOR_LOCK: null,
        MAX_VALUE_SENSOR_LOCK: null,
        FK_SENSOR_POS: null,
        FK_SENSOR_PRESSURE: null,
        REQ_PRES: null,
        NOTE: null
      };
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate,
        this.sensorMeasureState,
        this.actionSensorState,
        this.valueSensorState,
        this.feedbackErrTimeState,
        this.sensorMeasureLockState,
        this.lockRangeState,
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipmamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        "Selecione a medição do sensor de feedback.",
        "Selecione a condição de ativação (maior que / menor que).",
        "Informe o valor de referência para a condição de ativação.",
        "Informe o tempo máximo de confirmação do feedback (mínimo 1 segundo).",
        "Selecione a medição do sensor de bloqueio de segurança.",
        "Informe uma faixa mínimo/máximo válida para o sensor de bloqueio de segurança (mínimo menor que máximo).",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE =
        this.form.LATITUDE != "" && this.form.LATITUDE != null
          ? parseFloat(this.form.LATITUDE)
          : null;
      this.form.LONGITUDE =
        this.form.LONGITUDE != "" && this.form.LONGITUDE != null
          ? parseFloat(this.form.LONGITUDE)
          : null;
      this.form.REQ_PRES =
        this.form.REQ_PRES != "" && this.form.REQ_PRES != null
          ? parseFloat(this.form.REQ_PRES)
          : null;
      this.form.CLOSURE_TIME =
        this.form.CLOSURE_TIME > 0 || this.form.CLOSURE_TIME == null
          ? this.form.CLOSURE_TIME
          : null;

      if (this.form.POS_SENSOR == null) {
        this.form.ACTION_SENSOR = null;
        this.form.VALUE_SENSOR = null;
      }
      if (!this.form.FK_SENSOR) {
        this.form.FEEDBACK_ERR_ENABLED = 0;
        this.form.FEEDBACK_ERR_TIME = null;
      }
      if (this.form.POS_SENSOR_LOCK == null) {
        this.form.MIN_VALUE_SENSOR_LOCK = null;
        this.form.MAX_VALUE_SENSOR_LOCK = null;
      } else {
        this.form.MIN_VALUE_SENSOR_LOCK = parseFloat(this.form.MIN_VALUE_SENSOR_LOCK);
        this.form.MAX_VALUE_SENSOR_LOCK = parseFloat(this.form.MAX_VALUE_SENSOR_LOCK);
      }
      this.form.REST_TIME =
        this.form.REST_TIME >= 0 || this.form.REST_TIME == null
          ? this.form.REST_TIME
          : null;
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    }
  }
};
</script>

<style scoped>
#form{
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0em;
    margin-right: 0;
  }

}
</style>
